import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/home.vue'),
    meta:{ title:'打卡报表' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/login.vue'),
    meta:{ title:'登录' }
  }
]

const router = new VueRouter({
  routes
})

export default router
